var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{staticClass:"modal-collection-form",attrs:{"title":null,"maskClosable":false,"closable":false,"footer":null},on:{"ok":_vm.handleOk},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{style:({ height: _vm.modalHeight })},[_c('iframe',{ref:"contactFrame",style:({
          width: _vm.iframeWidth,
          height: _vm.iframeHeight,
          border: 'none',
        }),attrs:{"src":_vm.iframeUrl}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }